import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import api, { formatApiError } from "./api";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      toast.success(`Welcome back, ${data.name}`);
      onSuccess(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#111111] border border-[#333333] p-10">
        <div className="text-center mb-8">
          <span className="inline-block bg-white px-3 py-2 mb-4">
            <img src="/assets/logo.png" alt="Apex Home Renovation LLC" className="h-12 w-auto" />
          </span>
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Admin Dashboard</p>
        </div>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-gray-400">Email</label>
            <input required type="email" data-testid="admin-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent border-b border-[#333333] focus:border-[#D4AF37] text-white py-3 px-2 w-full outline-none transition-colors duration-300"
              placeholder="admin email" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-gray-400">Password</label>
            <input required type="password" data-testid="admin-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent border-b border-[#333333] focus:border-[#D4AF37] text-white py-3 px-2 w-full outline-none transition-colors duration-300"
              placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#050505] hover:bg-[#C9A227] transition-colors duration-300 px-8 py-3 uppercase tracking-widest text-sm font-semibold disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <a href="/" className="block text-center text-xs text-gray-500 hover:text-[#D4AF37] mt-6 transition-colors">
          ← Back to website
        </a>
      </div>
    </div>
  );
};
